import { useState, useEffect } from "react";
import { AxiosError } from "axios";
import { Link } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Table from "../../../core/common/dataTable/index";
import { LevelTable } from "../../../core/data/interface"; //Les types des colones de notre tableau déclaré au préalable
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { toast } from "sonner";
// pour restreaindre l'accès à ce composant
import withPermission from "../../../core/common/autorisations/withPermission";
import EditLevelModal from "./editLevelModal";
import CreateLevelModal from "./createLevelModal";
import { useAcademicYear } from "../../../core/common/context/AcademicYearContext";
import { getAllLevel, deleteLevel } from "../../../api/pedagogicElement";
import {
  Action,
  buildPermission,
  Resource,
} from "../../../core/common/autorisations/permissionsMap";
import InfosAlertYearDisabled from "../../../core/common/alerts/infosAlertYearDisabled";
import DashboardMenu from "../../user/admin/dashboardMenu";

// boutton protégée pour créer un niveau
const ProtectedBtnAddLevel = withPermission(
  (props: any) => (
    <div className="mb-2">
      <button
        onClick={() => {
          props.setShowCreate(true);
        }}
        //   to="#"
        className="btn btn-primary d-flex align-items-center"
      >
        <i className="ti ti-square-rounded-plus me-2" />
        Nouveau Niveau
      </button>
    </div>
  ),
  [buildPermission(Resource.LEVEL, Action.CREATE)],
  "masquer",
);

// boutton protégée pour modifier un niveau
const ProtectedBtnUpdateLevel = withPermission(
  (props: any) => (
    <li>
      <Link
        className="dropdown-item rounded-1"
        to="#"
        onClick={() => {
          props.setEditLevel(props.record.id);
          props.setShowEdit(true);
        }}
      >
        <i className="ti ti-edit-circle me-2" />
        Modifier
      </Link>
    </li>
  ),
  [buildPermission(Resource.LEVEL, Action.UPDATE)],
  "masquer",
);

// boutton protégée pour supprimer un niveau
const ProtectedBtnDeleteLevel = withPermission(
  (props: any) => (
    <li>
      <Link
        onClick={() => props.showConfirmationAlert(props.record)}
        className="dropdown-item rounded-1"
        to="#"
      >
        <i className="ti ti-trash-x me-2" />
        Supprimer
      </Link>
    </li>
  ),
  [buildPermission(Resource.LEVEL, Action.DELETE)],
  "masquer",
);

const LevelList = () => {
  const { selectedYear } = useAcademicYear();

  //Initialisation des state utilisés
  const [allLevels, setAllLevels] = useState([]);
  const [editLevel, setEditLevel] = useState("");
  const [isLoading, setIsLoading] = useState(true); // Pour le vrai chargement
  const [hasLoaded, setHasLoaded] = useState(false); // Pour éviter "Chargement..." quand il n'y a juste pas de données

  const [refreshKey, setRefreshKey] = useState(0);

  const [showCreate, setShowCreate] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  //Initialisation de sweetAlert
  const MySwal = withReactContent(Swal);

  // Les colonnes de notre tableau
  const columns = [
    {
      title: "Cycle",
      dataIndex: "cycle",
      sorter: (a: LevelTable, b: LevelTable) => a.cycle.length - b.cycle.length,
    },
    {
      title: "Libellé",
      dataIndex: "label",
      sorter: (a: LevelTable, b: LevelTable) => a.label.length - b.label.length,
    },
    {
      title: "Abréviation",
      dataIndex: "abbreviation",
      sorter: (a: LevelTable, b: LevelTable) =>
        a.abbreviation.length - b.abbreviation.length,
    },
    {
      title: "Date de création",
      dataIndex: "createdAt",
      render: (date: string) => {
        const d = new Date(date);
        return d.toLocaleDateString("fr-FR", {
          year: "numeric",
          month: "long",
          day: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
      sorter: (a: LevelTable, b: LevelTable) =>
        new Date(a.createdAt).getTime() - new Date(b.createdAt).getTime(),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (_: any, record: any) => (
        <>
          <div className="d-flex align-items-center">
            <div className="dropdown">
              <Link
                to="#"
                className="btn btn-white btn-icon btn-sm d-flex align-items-center justify-content-center rounded-circle p-0"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <i className="ti ti-dots-vertical fs-14" />
              </Link>
              <ul className="dropdown-menu dropdown-menu-right p-3">
                {/* modifier un niveau */}
                <ProtectedBtnUpdateLevel
                  setEditLevel={setEditLevel}
                  record={record}
                  setShowEdit={setShowEdit}
                />

                {/* supprimer un niveau */}
                <ProtectedBtnDeleteLevel
                  showConfirmationAlert={showConfirmationAlert}
                  record={record}
                />
              </ul>
            </div>
          </div>
        </>
      ),
    },
  ];

  //Traitement en alert de la demande de réinitialisation de mot de passe
  const showConfirmationAlert = (level: any) => {
    MySwal.fire({
      title: "Supprimer un Niveau d'Étude ?",
      text: `Souhaitez-vous vraiment supprimer le niveau ${level.label} ?`,
      showCancelButton: true,
      // confirmButtonColor: "#00ff00",
      confirmButtonText: "Envoyer!",
      // cancelButtonColor: "#ff0000",
      cancelButtonText: "Annuler",
    }).then(async (result) => {
      if (result.isConfirmed) {
        // ── Affiche le spinner pendant la requête ──
        MySwal.fire({
          title: "Suppression en cours...",
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => MySwal.showLoading(),
        });
        try {
          //On lance la requête d'envoi de mail
          await deleteLevel(level.id);
          MySwal.fire({
            title: "Niveau d'étude supprimé avec succès !",
            icon: "success",
            confirmButtonText: "OK",
          });

          reloadData(); //On reload la liste
        } catch (error) {
          const err = error as AxiosError<any>;
          //On affiche une alerte en cas d'erreur côté serveur
          MySwal.fire({
            title: "Erreur",
            text:
              err.response?.data?.message ||
              err.response?.data?.error ||
              "Une erreur est survenue, réessayez plus tard",
            icon: "error",
            confirmButtonText: "OK",
          });
        }
      }
    });
  };

  //Reload de la liste
  const reloadData = () => setRefreshKey((prev) => prev + 1);

  //On recupère la liste des Levels en appelant sa fonction
  useEffect(() => {
    const fetchData = async () => {
      // On attend que selectedYear soit défini
      if (!selectedYear?.id) return;

      setHasLoaded(false);
      setIsLoading(true);

      try {
        const level = await getAllLevel(selectedYear?.id);
        setAllLevels(level.data);
        // console.log("level", level.data)
      } catch (error: any) {
        // Si erreur (Toast Error)
        toast.error(
          error.message || "Une erreur s'est produit, Réessayer plus tard",
        );
      } finally {
        setIsLoading(false); //Les données ne sont plus en chargement
        setHasLoaded(true); //Les données ont été chargé avec succès
      }
    };

    fetchData();
  }, [refreshKey, selectedYear]);

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Page Header */}
          <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
            <DashboardMenu />
            {/* Boutton en entête de la page */}
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              {/* <TooltipOption/> */}
              <ProtectedBtnAddLevel setShowCreate={setShowCreate} />
            </div>
          </div>
          {/* /Page Header */}
          {!selectedYear?.statut && <InfosAlertYearDisabled />}
          {/* Tableau liste du personnel administratif */}
          <div className="card">
            <div className="card-header d-flex align-items-center justify-content-between flex-wrap pb-0">
              <h4 className="mb-3">Liste des Niveau d'Études</h4>
            </div>
            <div className="card-body p-0 py-3">
              {/* Staffs List (On affiche le tableau qui si les données son chargées même vide) */}
              {isLoading && !hasLoaded ? (
                <div className="text-center">
                  <div className="spinner-border" role="status"></div>
                  <span className="visually">Chargement des Données...</span>
                </div>
              ) : (
                <Table
                  columns={columns}
                  dataSource={allLevels}
                  Selection={true}
                />
              )}
              {/* /Staffs List */}
            </div>
          </div>
        </div>
        {/* /Page Header */}

        <EditLevelModal
          show={showEdit}
          levelID={editLevel}
          onClose={() => setShowEdit(false)}
          onSaved={reloadData}
        />
        <CreateLevelModal
          show={showCreate}
          onClose={() => setShowCreate(false)}
          onSaved={reloadData}
        />
      </div>
    </>
  );
};

// export default withPermission(AcademicYearList, "admin:access", "accès-refuser");
export default LevelList;
